module.exports = __webpack_public_path__ + "static/media/error-handling-poster.b727a368.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/posterImgs/error-handling-poster.jpg
// module id = 419
// module chunks = 0